<template>
  <v-container id="market-dashboard" fluid>
    <v-row align="start" justify="start">
      <v-col cols="12">
        <div v-if="getIsRole" ref="reportContainer" id="reportContainer"></div>
        <div v-else >
          <v-img id="reportContainer" :src="item.imgUrl" @click="showProDialog = true">  
            <pro-feature-dialog v-model="showProDialog" />
          </v-img>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script> 
import { hasRole } from '@/mixins/hasRole.js'
import { getPBIToken } from '@/mixins/getPBIToken.js'
import { mapGetters } from 'vuex'
import ProFeatureDialog from '@/components/ProFeature.vue'

export default { 
  mixins: [hasRole, getPBIToken], 
	components: {
    ProFeatureDialog
  },  
  data() {
		return {      
      item: {},
      showProDialog: false
    }
  },
  watch: {
   '$route'(){    
      const newItem = this.getItem()        
      this.showProDialog = true;          
      this.item = newItem        
      if(this.hasRole(this.item.role)){
        this.getPBIToken(this.item.pbiToken)     
      }       
    }
  },  
  mounted() {   
    this.showProDialog = true
    this.item = this.getItem()    
    if(this.hasRole(this.item.role)) {
      this.getPBIToken(this.item.pbiToken)     
    }
  }, 
  methods: {  
    getItem(){
      return this.getItemsDashboard.find(item => item.to === this.$router.currentRoute.fullPath)
    },
  },
  computed: {     
    getIsRole(){          
      return this.hasRole(this.item.role)               
    },
    ...mapGetters([
		  'getItemsDashboard',      		
	  ])
  }  
}
</script>

<style>
  #reportContainer {
    width: 100%;
    height: 800px;
  }
  iframe {
    border: none;
  }
</style>